/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_SuccessInputs */

const en_settings_tickets_create_success = /** @type {(inputs: Settings_Tickets_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket submitted`)
};

const zh_settings_tickets_create_success = /** @type {(inputs: Settings_Tickets_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单已提交`)
};

/**
* | output |
* | --- |
* | "Ticket submitted" |
*
* @param {Settings_Tickets_Create_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_success = /** @type {((inputs?: Settings_Tickets_Create_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_create_success(inputs)
	return zh_settings_tickets_create_success(inputs)
});
export { settings_tickets_create_success as "settings.tickets.create_success" }